(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authentic-chaos-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ac-home').forEach((home) => {
    const toggle = home.querySelector('[data-ac-menu-toggle]');
    const panel = home.querySelector('[data-ac-menu-panel]');
    const close = home.querySelector('[data-ac-menu-close]');

    if (!toggle || !panel || !close) return;

    const setMenu = (open) => {
      home.classList.toggle('menu-is-open', open);
      document.documentElement.classList.toggle('ac-menu-lock', open);
      toggle.setAttribute('aria-expanded', String(open));
      panel.setAttribute('aria-hidden', String(!open));
      if (open) close.focus();
      else toggle.focus();
    };

    toggle.addEventListener('click', () => setMenu(true));
    close.addEventListener('click', () => setMenu(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && home.classList.contains('menu-is-open')) setMenu(false);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
